<app-feedback-banner
    *ngIf="productSelectionError"
    variant="warning"
    i18n-header
    header="Error"
    i18n-message
    message="Product could not been added as there is already a product with the same product category assigned. If you want to replace a product please discontinue the old product first and maintain product life cycle."
    [showCloseIcon]="true"
    (closeMessage)="closeSelectionError()"
></app-feedback-banner>
<br />
<div class="alert alert-error shadow-lg" *ngIf="error()">
    <div class="w-full flex flex-row gap-4">
        <iota-icon icon="information-circle" size="1.5"></iota-icon>
        <span i18n>Error loading products!</span>
        <div class="flex-1"></div>
        <button class="btn btn-primary" (click)="reloadProducts()" i18n>Reload products</button>
    </div>
</div>
<app-sub-section-header [text]="title()">
    <ng-container buttons>
        <button *ngIf="!editMode" class="gap-2" (click)="edit()">
            <iota-icon icon="pencil-square" class="text-primary"></iota-icon>
            <span i18n>Edit products</span>
        </button>
        <button *ngIf="editMode" class="btn btn-accent gap-2" (click)="save()">
            <iota-icon flaticon="floppy-disk" size="1x"> </iota-icon>
            <span i18n>Save</span>
        </button>
        <button *ngIf="editMode" class="btn btn-error gap-2" (click)="cancel()">
            <iota-icon icon="x-mark"></iota-icon>
            <span i18n>Cancel</span>
        </button>
    </ng-container>
</app-sub-section-header>
<div class="flex flex-row flex-wrap gap-5">
    <div
        class="bg-gray-400 border-2 border-primary relative shadow-md flex flex-col items-center justify-center transition-all h-[190px] w-[200px] rounded-lg cursor-pointer hover:shadow-lg hover:scale-105"
        (click)="openAddProductsDialog()"
        *ngIf="editMode"
    >
        <iota-icon icon="plus" class="text-white" size="4"></iota-icon>
    </div>
    <div
        class="bg-gray-400 border-2 border-primary relative shadow-md flex flex-col gap-5 items-center justify-center transition-all h-[190px] w-[200px] rounded-lg cursor-pointer hover:shadow-lg hover:scale-105"
        (click)="addMockBasketProduct()"
        *ngIf="editMode"
    >
        <iota-icon icon="plus" class="text-white" size="4" *ngIf="mockBasketProductExists()"></iota-icon>
        <span class="text-lg text-white" *ngIf="mockBasketProductExists()" i18n>Mock product</span>
        <span class="text-lg text-center text-error" *ngIf="!mockBasketProductExists()" i18n>There is no mock basket product</span>
    </div>
    <app-registration-period-product-card
        *ngFor="let newProduct of newSelectedProducts(); trackBy: trackByProductSelection"
        [productSelection]="newProduct"
        [editMode]="editMode"
        [markedForAdd]="true"
        (markForDelete)="removeNewProduct($event)"
    ></app-registration-period-product-card>
    <app-registration-period-product-card
        *ngFor="let productSelection of activeSelectedProducts(); trackBy: trackByProductSelection"
        [productSelection]="productSelection"
        [editMode]="editMode"
        [markedForDelete]="markedForDelete.includes(productSelection.companyProductSelectionId)"
        (markForDelete)="markForDelete($event)"
        (undoDelete)="undoDelete($event)"
    ></app-registration-period-product-card>
</div>

<!-- dicontinued products subsection -->
<ng-container *ngIf="discontinuedSelectedProducts().length > 0">
    <div class="mt-6">
        <app-sub-section-header [text]="discontinuedSectionTitle"> </app-sub-section-header>
    </div>

    <div class="flex flex-row flex-wrap gap-5">
        <app-registration-period-product-card
            *ngFor="let productSelection of discontinuedSelectedProducts(); trackBy: trackByProductSelection"
            [productSelection]="productSelection"
            [editMode]="editMode"
            [markedForDelete]="markedForDelete.includes(productSelection.companyProductSelectionId)"
            (markForDelete)="markForDelete($event)"
            (undoDelete)="undoDelete($event)"
        ></app-registration-period-product-card>
    </div>
</ng-container>
